import { useUtils as useI18nUtils } from '@core/libs/i18n'
import { useUtils as useAclUtils } from '@core/libs/acl'
import { IS_REPORT_LOCKED } from '@/modules/account/store/types'
import { NEW_COPY } from '@/constants/appointment_report_v2'

const { t } = useI18nUtils()
const { canViewVerticalNavMenuHeader } = useAclUtils()

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  render(h) {
    const span = h('span', {}, t(this.item.header))
    const icon = h('feather-icon', { props: { icon: 'MoreHorizontalIcon', size: '18' } })
    if (canViewVerticalNavMenuHeader(this.item)) {
      // Trava de report pendente (board v4-pendencias): o aviso fica logo abaixo do cabeçalho; ao liberar, some
      // (esmaece e recolhe). Estilos em VerticalNavMenu.vue.
      const lockCaption = this.$store.getters[IS_REPORT_LOCKED]
        ? h('div', { key: 'report-lock-caption', class: 'nav-report-lock-caption' }, [
          h('div', { class: 'nav-report-lock-caption__inner' }, [
            h('feather-icon', {
              class: 'nav-report-lock-caption__icon',
              props: { icon: 'LockIcon', size: '12' },
              attrs: { 'aria-hidden': 'true' },
            }),
            h('span', { class: 'nav-report-lock-caption__text' }, NEW_COPY.menuLockedCaption),
          ]),
        ])
        : null
      const caption = h('transition', { props: { name: 'nav-report-lock-caption' } }, [lockCaption])

      return h('li', { class: 'navigation-header text-truncate' }, [span, icon, caption])
    }
    return h()
  },
}
